"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var account_1 = require("../../mock/account");
var currencies_1 = require("../../currencies");
function genBaseOperation(_a) {
    var account = _a.account, parentAccount = _a.parentAccount, rng = _a.rng, type = _a.type, amount = _a.amount;
    var ops = account.operations;
    var op = (0, account_1.genOperation)(parentAccount, account, ops, rng);
    op.type = type;
    if (["REDEEM", "SUPPLY"].includes(type)) {
        op.extra = {
            // FIXME make it more realistic using function of time
            rate: rng.next(0.005, 0.01)
        };
    }
    if (amount && ["REDEEM", "SUPPLY"].includes(type)) {
        op.extra = __assign(__assign({}, op.extra), { compoundValue: amount.toString() });
        op.value = amount.times(op.extra.rate);
    }
    else if (amount) {
        op.value = amount;
    }
    ops.push(op);
    return op;
}
function addOperationWithType(account, rng, type, amount) {
    var _a;
    var subAccounts = ((_a = account === null || account === void 0 ? void 0 : account.subAccounts) === null || _a === void 0 ? void 0 : _a.length) ? account.subAccounts : [];
    var daiAccount = subAccounts.find(function (sub) { return sub.type === "TokenAccount" && (0, currencies_1.findCompoundToken)(sub.token); });
    genBaseOperation({
        parentAccount: account,
        account: daiAccount || account,
        rng: rng,
        type: type,
        amount: amount
    });
    return account;
}
function addSupplyOperations(account, rng, supplyVal) {
    addOperationWithType(account, rng, "SUPPLY", supplyVal);
    return account;
}
function addRedeemOperations(account, rng, redeemVal) {
    addOperationWithType(account, rng, "REDEEM", redeemVal);
    return account;
}
function addApproveOperations(account, rng) {
    addOperationWithType(account, rng, "APPROVE");
    return account;
}
function genAccountEnhanceOperations(account, rng) {
    var nbrRounds = rng.nextInt(1, 4);
    var output = [];
    var redeemable = 0;
    for (var i = 0; i < nbrRounds; i++) {
        var toSupply = rng.nextInt(0, 3000);
        redeemable += toSupply;
        var toRedeem = rng.nextInt(0, redeemable);
        var nbrSupplyOps = rng.nextInt(1, 2);
        var nbrRedeemOps = rng.nextInt(1, 2);
        for (var j = 0; j < nbrSupplyOps; j++) {
            var supplyVal = j === nbrSupplyOps - 1 ? toSupply : rng.nextInt(0, toSupply);
            toSupply -= supplyVal;
            output.push({
                args: [account, rng, new bignumber_js_1.BigNumber(supplyVal)],
                type: "supply"
            }); // addSupplyOperations(account, rng, BigNumber(supplyVal));
        }
        for (var k = 0; k < nbrRedeemOps; k++) {
            var redeemVal = k === nbrRedeemOps - 1 ? toRedeem : rng.nextInt(0, toRedeem);
            toRedeem -= redeemVal;
            redeemable -= redeemVal;
            output.push({
                args: [account, rng, new bignumber_js_1.BigNumber(redeemVal)],
                type: "redeem"
            }); // addRedeemOperations(account, rng, BigNumber(redeemVal));
        }
    }
    output.reverse().forEach(function (_a) {
        var args = _a.args, type = _a.type;
        if (type === "supply") {
            addSupplyOperations.apply(void 0, __spreadArray([], __read(args), false));
        }
        if (type === "redeem") {
            addRedeemOperations.apply(void 0, __spreadArray([], __read(args), false));
        }
    });
    addApproveOperations(account, rng);
    return account;
}
function postSyncAccount(account) {
    return account;
}
function postScanAccount(account) {
    return account;
}
exports["default"] = {
    genAccountEnhanceOperations: genAccountEnhanceOperations,
    postSyncAccount: postSyncAccount,
    postScanAccount: postScanAccount
};
//# sourceMappingURL=mock.js.map